import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import ConfigPanelService from "@src/services/ConfigPanelService";
import { APIResponse } from '../types/Common';
import { STATUS_SUCCESS } from "@src/config/constant";
import WpcDays from "@src/component/config-panel/WpcDays";
//import AgentCommission from "@src/component/config-panel/AgentCommission";

const configPanel = createSlice({
    name: 'configPanel',
    initialState: {
        vehicleAge: [],
        basicPremium:[],
        adminFee:[],
        loadingRate:[],
        addonList:[],
        addonsData:[],
        agentCommission:[],
        wpcDaysData:[],
        xenditFeeData:[]
    },
    reducers: {
        
        setVehicleAge: (state, action: any) => {
            state.vehicleAge = action.payload;
        },
        setBasicPremium: (state, action: any) => {
            state.basicPremium = action.payload;
        },
        setAdminFee: (state, action: any) => {
            state.basicPremium = action.payload;
        },
        setloadingRate: (state, action: any) => {
            state.loadingRate = action.payload;
        },
        setAddonList: (state, action: any) => {
            state.addonList = action.payload;
        },
        setAddonsData: (state, action: any) => {
            state.addonsData = action.payload;
        },
        setAgentCommission: (state, action: any) => {
            state.agentCommission = action.payload;
        },
        setWpcDaysData: (state, action: any) => {
            state.agentCommission = action.payload;
        },
        setXenditFeeData: (state, action: any) => {
            state.xenditFeeData = action.payload;
        },
    },
});

export default configPanel.reducer;

export const { setVehicleAge,setBasicPremium,setAdminFee,setloadingRate,setAddonList,setAddonsData,setAgentCommission,setWpcDaysData,setXenditFeeData } = configPanel.actions




export const getVehicleAge = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getVehicleAge(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setVehicleAge(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const saveVehicleAge = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveVehicleAge(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getBasicPremium = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getBasicPremium(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setBasicPremium(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const saveBasicPremium = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveBasicPremium(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}
export const deleteBasicPremium = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.deleteBasicPremium(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getAdminFee = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getAdminFee(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setAdminFee(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const saveAdminFee = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveAdminFee(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getLoadingRate = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getLoadingRate(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setloadingRate(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getAddonList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getAddonList(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setAddonList(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const saveLoadingRate = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveLoadingRate(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const updateAddonCode = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.updateAddonCode(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}
export const updateAddonsRate = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.updateAddonsRate(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const deleteAddonRate = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.deleteAddonRate(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const fetchAddonsRate = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.fetchAddonsRate(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setAddonsData(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getAgentCommission = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getAgentCommission(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setAgentCommission(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const saveAgentCommission = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveAgentCommission(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const deleteAgentCommission = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.deleteAgentCommission(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getWpcDays = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getWpcDays(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setWpcDaysData(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const saveWpcDays = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveWpcDays(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const getXenditFee = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getXenditFee(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                resolve(response.data)
                dispatch(setXenditFeeData(response?.data?.data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const saveXenditFee = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveXenditFee(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}

export const saveBranchConfig = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveBranchConfig(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}
export const getBranchConfig = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getBranchConfig(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}
export const deleteBranchConfig = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.deleteBranchConfig(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}


export const saveMultiTenure = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveMultiTenure(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}
export const getMultiTenure = (params: object) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getMultiTenure(params)
        .then(
            (response: APIResponse) => {
                if ((response && response.data && response.data.status) === STATUS_SUCCESS) {
                    resolve(response.data)
                }
                else {
                    let errorMsg = (response && response.data && response.data.message) || ''
                    if (errorMsg) toast.error(response.data.message);
                    resolve(response && response.data)
                }
            },
            (error: Error) => {
                reject(error);
            }
        )
    })
}